import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
const resources = {
  de: {
    widget: {
      // Confirmation Dialog
      confirmation: {
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        updateRequest: 'Anfrage aktualisieren',
        updateDescription: 'Hotels dieser Buchung werden mit aktualisierten Informationen neu angefragt',
      },
      // Capsule tabs
      tabs: {
        place: 'Ort',
        date: 'Termin',
        participants: 'Teilnehmer',
        rooms: 'Räume',
        overnight: 'Übernachtungen',
        catering: 'Verpflegung',
        tooltip: {
          rooms: 'Räume',
        },
      },
      // Form placeholders
      placeholder: {
        placeOrHotel: 'Ort oder Hotel eingeben',
        noDate: 'keine',
        notSet: 'nicht gesetzt',
      },
      // Search results
      search: {
        searching: 'Suche...',
        noResults: 'Keine Ergebnisse gefunden',
        hotels: 'Hotels',
        places: 'Orte',
      },
      // Buttons
      buttons: {
        search: 'Suchen',
        details: 'Details',
        close: 'X',
        addRoom: '+ Raum hinzufügen',
        continue: 'Weiter',
        planMeeting: 'Seminar planen',
      },
      // Service types
      serviceTypes: {
        fullDay: 'Ganztags',
        halfDay: 'Halbtags',
        small: 'Klein',
        regular: 'Ganztags',
        medium: 'Halbtags',
        packageSmall: 'Pauschale "klein"',
        packageHalfDay: 'Pauschale "Halbtags"',
        packageFullDay: 'Pauschale "Ganztags"',
        coffeeBreak: 'Kaffeepause',
        lunch: 'Mittagessen',
        roomAndTech: 'In allen Pauschalen ist die Raumnutzung sowie die Standardtechnik enthalten.',
        dinner: 'Abendessen',
        dinnerTime: '18:00 bis 21:00 Uhr möglich',
        added: 'hinzugefügt',
        enterPersonCount: 'Bitte tragen Sie die Anzahl der Personen für',
        in: 'ein.',
        personCount: 'Anzahl Personen',
        personsAssigned: 'Personen von',
        assigned: 'zugeteilt',
      },
      // Addons
      addons: {
        coffee: 'Empfangskaffee',
        dinner: 'Abendessen',
      },
      // Table headers
      table: {
        duration: 'Dauer',
        seating: 'Bestuhlung',
        seatCount: 'Anzahl Plätze',
        room: 'Raum',
      },
      // Time options
      time: {
        fullDay: 'Ganztägig',
        morning: 'Vormittag',
        afternoon: 'Nachmittag',
      },
      // Seating types
      seating: {
        theater: 'Theater',
        parliament: 'Parlament',
        circle: 'Kreis',
        banquet: 'Bankett',
        cocktail: 'Cocktail',
        block: 'Block',
        uform: 'U-Form',
      },
      // Room descriptions
      room: {
        extensionNight: 'Verlängerungsnacht',
        day: 'Tag',
        arrivalPrevDay: 'Anreise Vortag',
        personsInSingle: 'Personen im Einzelzimmer',
        personsInDouble: 'Personen im Doppelzimmer',
      },
      // Day switch
      daySwitch: {
        arrivalPrevDay: 'Anreise Vortag',
        day: 'Tag',
      },
      // Headers
      headers: {
        pleaseEnterParticipants: 'Bitte geben Sie die Teilnehmeranzahl an.',
        pleaseEnterRoomDetails: 'Bitte geben Sie die Seminarraumdetails an.',
        pleaseEnterOvernights: 'Bitte geben Sie die Anzahl der Übernachtungen an.',
        pleaseEnterCatering: 'Bitte wählen Sie Ihre Verpflegungspauschale.',
      },
      // Labels
      labels: {
        seating: 'Bestuhlung',
        participants: 'Teilnehmer',
        uform: 'U-Form',
      },
      // Time labels
      timeLabels: {
        from: 'Von',
        to: 'Bis',
      },
      // Room labels
      roomLabels: {
        seminarDays: 'Seminartage',
        additionalNight: 'Zusatznacht',
        on: 'auf',
      },
      // Room equipment
      roomEquipment: {
        included: 'inkludiert:',
        beamer: '1x Beamer & Leinwand / Flatscreen',
        flipchart: '1x Flipchart',
        pinboard: '1x Pinnwand',
      },
    },
  },
  en: {
    widget: {
      // Confirmation Dialog
      confirmation: {
        cancel: 'Cancel',
        confirm: 'Confirm',
        updateRequest: 'Update Request',
        updateDescription: 'Hotels in this booking will be re-requested with updated information',
      },
      // Capsule tabs
      tabs: {
        place: 'Location',
        date: 'Date',
        participants: 'Participants',
        rooms: 'Rooms',
        overnight: 'Accommodation',
        catering: 'Catering',
        tooltip: {
          rooms: 'Rooms',
        },
      },
      // Form placeholders
      placeholder: {
        placeOrHotel: 'Enter location or hotel',
        noDate: 'none',
        notSet: 'not set',
      },
      // Search results
      search: {
        searching: 'Searching...',
        noResults: 'No results found',
        hotels: 'Hotels',
        places: 'Places',
      },
      // Buttons
      buttons: {
        search: 'Search',
        details: 'Details',
        close: 'X',
        addRoom: '+ Add Room',
        continue: 'Continue',
        planMeeting: 'Plan Meeting',
      },
      // Service types
      serviceTypes: {
        fullDay: 'Full Day',
        halfDay: 'Half Day',
        small: 'Small',
        regular: 'Full Day',
        medium: 'Half Day',
        packageSmall: 'Small Package',
        packageHalfDay: 'Half Day Package',
        packageFullDay: 'Full Day Package',
        coffeeBreak: 'Coffee Break',
        lunch: 'Lunch',
        roomAndTech: 'All packages include room usage and standard technology.',
        dinner: 'Dinner',
        dinnerTime: 'Available 6:00 PM to 9:00 PM',
        added: 'added',
        enterPersonCount: 'Please enter the number of people for',
        in: '',
        personCount: 'Number of People',
        personsAssigned: 'people of',
        assigned: 'assigned',
      },
      // Addons
      addons: {
        coffee: 'Welcome Coffee',
        dinner: 'Dinner',
      },
      // Table headers
      table: {
        duration: 'Duration',
        seating: 'Seating',
        seatCount: 'Number of Seats',
        room: 'Room',
      },
      // Time options
      time: {
        fullDay: 'All Day',
        morning: 'Morning',
        afternoon: 'Afternoon',
      },
      // Seating types
      seating: {
        theater: 'Theater',
        parliament: 'Parliament',
        circle: 'Circle',
        banquet: 'Banquet',
        cocktail: 'Cocktail',
        block: 'Block',
        uform: 'U-Shape',
      },
      // Room descriptions
      room: {
        extensionNight: 'Extension Night',
        day: 'Day',
        arrivalPrevDay: 'Arrival Previous Day',
        personsInSingle: 'People in Single Room',
        personsInDouble: 'People in Double Room',
      },
      // Day switch
      daySwitch: {
        arrivalPrevDay: 'Arrival Previous Day',
        day: 'Day',
      },
      // Headers
      headers: {
        pleaseEnterParticipants: 'Please enter the number of participants.',
        pleaseEnterRoomDetails: 'Please enter the meeting room details.',
        pleaseEnterOvernights: 'Please enter the number of overnight stays.',
        pleaseEnterCatering: 'Please select your catering package.',
      },
      // Labels
      labels: {
        seating: 'Seating',
        participants: 'Participants',
        uform: 'U-Shape',
      },
      // Time labels
      timeLabels: {
        from: 'From',
        to: 'To',
      },
      // Room labels
      roomLabels: {
        seminarDays: 'Seminar Days',
        additionalNight: 'Additional Night',
        on: 'on',
      },
      // Room equipment
      roomEquipment: {
        included: 'included:',
        beamer: '1x Projector & Screen / Flatscreen',
        flipchart: '1x Flipchart',
        pinboard: '1x Pinboard',
      },
    },
  },
};

// Initialize i18n synchronously with resources
if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: 'de', // Default language
    fallbackLng: 'de',
    defaultNS: 'widget',
    ns: ['widget'],
    interpolation: {
      escapeValue: false,
    },
    debug: false,
    keySeparator: '.',
    nsSeparator: ':',
    react: {
      useSuspense: false,
    },
    initImmediate: false, // Initialize synchronously
  });
}

export default i18n;
